export class Assignment {
    id: number;
    statusId: number;
    status: string;
    assignedToId: number;
    assignedTo: string;
}
